import { useConfig } from 'builder/hooks/useConfig'

export const useDownloadButtonABTest = () => {
  const config = useConfig()

  const isDownloadButtonABTestActive =
    config?.features?.rbpNewDownloadBtn === 'v1' || config?.features?.rbpNewDownloadBtn === 'v2'

  const downloadButtonABTestVersion = config?.features?.rbpNewDownloadBtn

  return {
    isDownloadButtonABTestActive,
    downloadButtonABTestVersion,
  }
}
